import React, { useCallback, useEffect, useState } from 'react'
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import SvgIcon from '@mui/material/SvgIcon'
import CircularProgress from '@mui/material/CircularProgress'

const StyledSvgIcon = withStyles({
  root: {
    fontSize: '18px',
    marginBottom: '-3px',
    marginRight: '6px',
    marginLeft: '-2px',
  },
})(SvgIcon)

const createFolderIcon = function(rights) {
  let folderColor = '#aaa'
  if (rights[0] && rights[4]) {
    // Invisible
    folderColor = '#b0d4e8'
  } else if (rights[0]) {
    // Read
    folderColor = '#f2dea5'
  }

  return (
    <StyledSvgIcon>
      <path
        d='M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z'
        fill={folderColor}
      />
      {rights[1] && (
        <path
          d='M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z'
          transform='translate(9, -2)'
          fill='red'
        />
      )}
      {rights[2] && (
        <text x='18' y='22' fontSize='12' fontWeight='bold' textAnchor='middle'>
          W
        </text>
      )}
      {rights[3] && (
        <text x='18' y='22' fontSize='12' fontWeight='bold' textAnchor='middle'>
          S
        </text>
      )}
    </StyledSvgIcon>
  )
}

const LoadingCircFolderIcon = withStyles({
  root: {
    marginLeft: '-1px',
    marginTop: '-8px',
    color: '#666',
    position: 'absolute',
  },
})(CircularProgress)

const LoadingCircIcon = withStyles({
  root: {
    color: 'rgb(189, 189, 189)',
  },
})(CircularProgress)

const useDotStyles = makeStyles({
  dots: {
    position: 'relative',
    paddingTop: ({vPadding}) => vPadding,
  },
  dot: {
    position: 'absolute',
    width: ({size}) => size,
    height: ({size}) => size,
    borderRadius: ({size}) => size/2.0,
  },
})

const LoadingDotsIcon = function({ count=3, defaultColor='lightgray', hightlightColor='gray', size=8, vPadding=0, hPadding=0 }) {
  const classes = useDotStyles({size, vPadding, hPadding})

  const [index, setIndex] = useState(0)
  const [timer, setTimer] = useState(null)

  const nextDot = useCallback(() => {
    setIndex((index + 1) % count)
  }, [index, count])

  useEffect(() => {
    setTimer(setTimeout(nextDot, 200))
  }, [nextDot])

  useEffect(() => {
    return () => {
      if (timer != null) {
        clearTimeout(timer)
      }
    }
  }, [timer])

  return <div className={classes.dots}>
    {[...Array(count).keys()].map((i) => (
      <div
        key={i}
        className={classes.dot}
        style={{
          left: hPadding + size * 2 * i,
          background: i === index ? hightlightColor : defaultColor,
        }}
      />
    ))}
  </div>
}

const TableLargeIcon = function() {
  return <SvgIcon>
    <path d="M4,3H20A2,2 0 0,1 22,5V20A2,2 0 0,1 20,22H4A2,2 0 0,1 2,20V5A2,2 0 0,1 4,3M4,7V10H8V7H4M10,7V10H14V7H10M20,10V7H16V10H20M4,12V15H8V12H4M4,20H8V17H4V20M10,12V15H14V12H10M10,20H14V17H10V20M20,20V17H16V20H20M20,12H16V15H20V12Z"/>
  </SvgIcon>
}

const LinkPlusIcon = function() {
  return <SvgIcon>
    <path fill="currentColor" d="M7,7H11V9H7A3,3 0 0,0 4,12A3,3 0 0,0 7,15H11V17H7A5,5 0 0,1 2,12A5,5 0 0,1 7,7M17,7A5,5 0 0,1 22,12H20A3,3 0 0,0 17,9H13V7H17M8,11H16V13H8V11M17,12H19V15H22V17H19V20H17V17H14V15H17V12Z" />
  </SvgIcon>
}

const TableIcon = (params) => {
  return <SvgIcon {...params}>
    <path fill="currentColor" d="M5,4H19A2,2 0 0,1 21,6V18A2,2 0 0,1 19,20H5A2,2 0 0,1 3,18V6A2,2 0 0,1 5,4M5,8V12H11V8H5M13,8V12H19V8H13M5,14V18H11V14H5M13,14V18H19V14H13Z" />
  </SvgIcon>
}

const SimpleTableIcon = (params) => {
  return <SvgIcon {...params}>
    <path fill="currentColor" d="M5,4L19,4C20.097,4 21,4.903 21,6L21,18C21,19.097 20.097,20 19,20L5,20C3.903,20 3,19.097 3,18L3,6C3,4.903 3.903,4 5,4M5,8L5,18L19,18L19,8L5,8" />
  </SvgIcon>
}

export { createFolderIcon, LoadingCircFolderIcon, LoadingCircIcon, LoadingDotsIcon, TableLargeIcon, LinkPlusIcon, TableIcon, SimpleTableIcon }
